import React from 'react';
import IdentityProviderButton from './IdentityProviderButton';

/**
 * Render the identity provider buttons for login or registration.
 *
 * Props:
 * - method: 'login' or 'register'
 */
interface LoginOrRegisterButtonsProps {
  /** Whether these buttons drive a login or a registration. */
  method: 'login' | 'register';
}

const LoginOrRegisterButtons = ({ method }: LoginOrRegisterButtonsProps) => {
  return (
    <div className="provider-buttons-wrapper w-full">
    <div className="kul-login">
      <IdentityProviderButton method={method} provider="kuleuven" />
    </div>
    <div className="other-login">
      <span>… or {method} with</span>
      <IdentityProviderButton method={method} provider="google" />
    </div>
  </div>
);
}

export default LoginOrRegisterButtons;
